import { no_propagate } from "./utils";

// The voyages of the currently selected person. Only reachable while a person
// is selected, so the button that opens it is hidden the rest of the time.
const MenuPerson = ({ active, people, selected_person, set_selected_trip, close_menu }) => {

  if (selected_person === null) return null;

  const person = people[selected_person];

  const select_trip = (trip_index) => {
    close_menu();
    set_selected_trip(trip_index);
  };

  return (
    <div className={"menu_panel" + (active ? "" : " menu_panel_hidden")}
         onClick={close_menu}>
      <label className="info_label">{person.name}'s Voyages</label>
      <ul className="info_button_list">
        {person.person_trips.map((person_trip) => (
          <li className="info_button" key={person_trip.trip_index}
              onClick={no_propagate(() => select_trip(person_trip.trip_index))}>
            {person_trip.trip.trip_key_memory} ({person_trip.trip.trip_date})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MenuPerson;
